<template>
  <!-- <v-row>
    <v-col class="pa-4 ma-4" cols="4">
      <v-img src="@/assets/Header/header_logo.png"></v-img>
    </v-col>
  <v-col>-->
  <!-- <v-card
    class="mx-auto overflow-hidden"
    height="400"
    width="344"
  >-->
  <div
    :class="drawer?'card':''"
    :style="drawer?'width:100%; height:600px; max-height:100%; z-index:99; ':'width:100%; height:64px;'"
    :color="drawer?'white':'transparent'"
  >
    <v-app-bar flat color="transparent" background-color="transparent" clipped-left>
      <!-- <div> -->
      <!-- <a href="/"  class="hidden-md-and-up" style="padding:0;margin:0;"> -->
      <v-img
        width="22%"
        class="hidden-md-and-up"
        style="padding:0;margin:0;"
        v-on:click="tohome"
        max-width="22%"
        src="@/assets/Footer/logo_fundacion_pcshek.png"
      ></v-img>
      <!-- </a> -->
      <!-- </div> -->

      <v-app-bar-nav-icon
        floating="24"
        color="purpure"
        align-center
        justify-center
        absolute
        @click.stop="drawer = !drawer"
        class="hidden-md-and-up"
        style="right:0;"
      ></v-app-bar-nav-icon>
      <!-- <div>
      <v-img src="@/assets/Header/header_logo.png" class="imglogo"></v-img>
      </div>-->
      <!-- <v-container > -->
      <v-row justify="end">
        <v-col cols="2"></v-col>
        <v-col class="text-right">
          <v-btn
            v-for="(link, i) in itemsnomobile"
            :key="i"
            v-bind="link"
            text
            class="hidden-sm-and-down h-btn"
            :color="color"
            @click="onClick($event, link)"
            style="text-shadow: black 0.1em 0.1em 0.2em"
          >
            {{link.text}}
          </v-btn>
        </v-col>
        <!-- <v-spacer /> -->
      </v-row>
      <!-- </v-container> -->
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" bottom temporary>
      <v-list nav dense>
        <v-list-item-group v-model="group" active-class="deep-orange--text text--accent-4">
          <v-list-item
            v-for="(link, i) in items"
            :key="i"
            v-bind="link"
            @click="onClick($event, link)"
          >
            <v-list-item-content>
              <v-list-item-title style="text-align:center;">{{link.text}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
  <!-- </v-card> -->
  <!-- </v-col>
  </v-row>-->
</template>

<script>
// import Header from "@/layout/components/header.vue";
// Utilities
// import { mapGetters, mapMutations } from "vuex";

export default {
  components: {
    // Header
  },
  name: "CoreAppBar",
  data() {
    return {
      drawer: false,
      group: null,
      items: [
        // {
        //   text: "Home",
        //   href: "/"
        // },
        {
          text: "Nosotros",
          href: "/nosotros"
        },

        {
          text: "Cómo lo hacemos",
          href: "/comolohacemos"
        },
        {
          text: "Proyectos",
          href: "/proyectos"
        },
        {
          text: "Donaciones",
          href: "/donaciones"
        },
        {
          text: "Museo",
          href: "/museo"
        },
        {
          text: "Contacto",
          href: "/contacto"
        }
      ],
      color: "white"
    };
  },
  computed: {
    itemsnomobile() {
      return this.items.filter(t => t.href != "/");
    }
    // ...mapGetters(["links"])
  },

  methods: {
    tohome() {
      this.color="white"
      return this.$router.push("/");
    },
    // ...mapMutations(["toggleDrawer"]),
    onClick(e, item) {
      e.stopPropagation();
      if (!item.href) return;

      // this.$vuetify.goTo(item.href.endsWith("!") ? 0 : item.href);
    }
  },
  created() {
    setTimeout(() => {
      // console.log(this.$route)
      // if (
      //   this.$route.name == "Home" ||
      //   this.$route.name == "Como lo hacemos" ||
      //   this.$route.name == "Proyectos" ||
      //   this.$route.name == "Reacondicionar" ||
      //   this.$route.name == "Museo"
      // )
      //   this.color = "white";
      // if (
      //   this.$route.name == "Nosotros" ||
      //   this.$route.name == "Comunidad virtual" ||
      //   this.$route.name == "Donaciones" ||
      //   this.$route.name == "Contacto"
      // )
      //   this.color = "#4e6093";
      if (this.$route.name == "Computadores viajeros") this.color = "#e58e0e";
    }, 100);
  }
};
</script>
<style scoped>
.right {
  float: right;
  text-align: right;
  /* width: 100%; */
  /* width: 80%; */
  /* width: 300px; */
  /* border: 3px solid #73AD21; */
  /* padding: 10px; */
}
.v-btn--active .v-btn__content {
  color: white;
}
</style>
